import { useId } from "react";
import { useSelector } from "react-redux";
import { locationName } from "../FulfilmentLocation/useWarehouseChange";
import { showFulfilmentLocation } from "../FulfilmentLocation/showFulfilmentLocation";

// Under the My Products title: the fulfilment location the products come
// from, with a link back to the Fulfilment Location card (the only place to
// choose it). Read-only: it writes nothing and requests nothing. Hidden for an
// account with no approved warehouse, which has no card to go to.
export default function ProductsLocationLine({ StepCheck }) {
  const user = useSelector((state) => state.user);
  const statusId = useId();
  const approved = Array.isArray(user?.user_approved_warehouses)
    ? user.user_approved_warehouses
    : [];
  if (!approved.length) return null;

  const selected = StepCheck["Warehouses"];
  const hasSelection = selected !== "" && selected !== null && selected !== undefined;
  const current = hasSelection
    ? approved.find((entry) => String(entry?.warehouse_id) === String(selected))
    : undefined;

  return (
    <div className="myprod__loc">
      {/* The button's description, so "Change" / "Choose" is read with it. */}
      {current ? (
        <span id={statusId}>
          Location: <b title={locationName(current)}>{locationName(current)}</b>
        </span>
      ) : (
        <span id={statusId}>No location chosen</span>
      )}
      <span className="myprod__loc-dot" aria-hidden="true">
        ·
      </span>
      <button
        type="button"
        className="myprod__loc-btn"
        aria-describedby={statusId}
        onClick={showFulfilmentLocation}
      >
        {current ? "Change" : "Choose"}
      </button>
    </div>
  );
}
